import * as yup from "yup";

import { FormId } from "../../../../components/enums";
import {
  policeDepartmentValidatorRequired,
  radioValidator,
} from "../../../../utilities/validators";
import { trimmedString } from "../../../../utilities/validators/trimmedString";

import { ComponentId } from "./enums";

export const validator = {
  [FormId.INCIDENT_STATEMENTS]: yup.object({
    [ComponentId.INCIDENT_STATEMENTS_POLICE_PRESENT]: radioValidator,
    [ComponentId.INCIDENT_STATEMENTS_PERPETRATOR_STATEMENT]: yup
      .string()
      .when(ComponentId.INCIDENT_STATEMENTS_POLICE_PRESENT, {
        is: (value: string) => value !== "true",
        then: radioValidator,
      }),
    [ComponentId.INCIDENT_STATEMENTS_POLICE_DEPARTMENT]: trimmedString.onlyIfFieldIsVisible(
      policeDepartmentValidatorRequired
    ),
    // LPPLWEBMOB-756
    // [ComponentId.INCIDENT_STATEMENTS_CASE_NUMBER]: trimmedString.onlyIfFieldIsVisible(
    //   statementCaseNumberValidatorRequired
    // ),
  }),
};
